// Relojes de la captura (ADR 0004 §1): `t_mono` en µs enteros desde el origen de la sesión y
// `t_wall` en ms Unix.

/** Reloj de la sesión; inyectable en pruebas. */
export interface CaptureClock {
  /** µs enteros desde el origen (monotónico). */
  mono(): number;
  /** ms Unix. */
  wall(): number;
  /** Convierte un instante de `performance.now()` (ms) a `t_mono`. */
  fromPerf(ms: number): number;
}

/** Reloj real basado en `performance.now()` con origen en el momento de crearlo. */
export function createClock(perf: { now(): number } = performance, date = Date): CaptureClock {
  const origin = perf.now();
  const fromPerf = (ms: number) => Math.max(0, Math.round((ms - origin) * 1000));
  return {
    mono: () => fromPerf(perf.now()),
    wall: () => date.now(),
    fromPerf,
  };
}

/** Espera `ms` milisegundos. */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
